module.exports = __webpack_public_path__ + "static/media/Weprologologin.7088fb49.svg";